import { Translation } from "@/data/lang";

export type DividendBoardType = "dividend" | "EPS";

export const getDividendOptionsMap = ({
  t,
}: {
  t: Translation;
}): Record<DividendBoardType, string> => ({
  dividend: t.analysis.dividend.history.dividend,
  EPS: t.analysis.dividend.history.EPS,
});
